import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'executeFunc',
    standalone: false
})
export class ExecuteFuncPipe implements PipeTransform {
  transform(arg: any, func: (...args: any[]) => any): any {
    return func(arg);
  }
}
